import React, { useEffect, useRef, useState } from "react";
import { useShoppingCart } from "../providers/ShoppingCartProvider";

import { Trans, useTranslation } from "react-i18next";
import Card from "@mui/material/Card";
import MUILink from "@mui/material/Link";
import makeStyles from "@mui/styles/makeStyles";
import { CardContent, MenuItem, Select } from "@mui/material";
import IconButton from "@mui/material/IconButton";
import { useTheme } from "@mui/material/styles";

import {
  PriceContainer,
  ProductInfo,
} from "../Mobile/Components/ShoppingCart";

import { formatCurrency, getClientType } from "../../utils";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import {
  PRODUCT_CATALOGUE_UUID,
  PRODUCT_PACKAGE_UUID,
  PRODUCT_RETOUCH_FILE_UUID,
  productUuidIsDigitalFileProduct,
  productUuidIsDigitalSetProduct,
  usePriceList,
} from "../providers/PriceListProvider";
import { Link } from "react-router-dom";
import useIsMobileDevice from "../../hooks/useIsMobileDevice";
import Icon from "@mui/material/Icon";
import TemplateProductPreview from "../Mobile/Components/EditTemplateProduct/TemplateProductPreview";
import QuantitySelector from "./QuantitySelector";
import DeleteOrderLineDialog from "../Mobile/Pages/ShoppingCart/Components/DeleteOrderLineDialog";
import { generatePath } from "react-router";
import useRoutes, {
  getLinkComponentAttributes,
  useHistory,
} from "../hooks/useRoutes";
import EpmsImage from "../../components/Common/EpmsImage";
import FormControl from "@mui/material/FormControl";
import Button from "@mui/material/Button";
import CatalogueIcon from "../../components/Icons/CatalogueIcon";
import DigitalFileIcon from "../../components/Icons/DigitalFileIcon";
import useGoogleFonts from "../../hooks/useGoogleFonts";
import { templateFontList } from "../../components/Template/common";
import { getProductTitle } from "@/react/Webshop/utils/orders";

const useStyles = makeStyles((theme) => ({
  appBar: {
    backgroundColor: "#ECECEC",
    color: "black",
    "& .MuiToolbar-root": {
      display: "flex",
      justifyContent: "space-between",
    },
  },
  summaryList: {
    listStyle: "none",
    margin: 0,
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
    paddingRight: theme.spacing(2),
    paddingLeft: theme.spacing(2),
    fontSize: "14px",
    "& > li": {
      display: "flex",
      justifyContent: "space-between",
    },
  },
  summaryDescription: {
    fontSize: "16px",
  },
  summaryTotal: {
    fontSize: "20px",
    fontWeight: "700",
  },
  productPreviewContainer: {
    backgroundColor: theme.palette.primary.light,
    minWidth: "100px",
    marginRight: theme.spacing(8),
    position: "relative",
    width: "344px",
    display: "flex",
    boxSizing: "border-box",
    padding: theme.spacing(3),
    [theme.breakpoints.down("sm")]: {
      justifyContent: "center",
      flexGrow: 1,
      width: 0,
      marginRight: theme.spacing(2),
      padding: theme.spacing(1),
    },
    "&.package": {
      backgroundColor: theme.palette.secondary.light,
    },
    "&.retouch": {
      backgroundColor: theme.palette.primary.light,
      backgroundImage: `repeating-linear-gradient(
           -45deg,
           rgba(255,255,255,0.3) 0px,
           rgba(255,255,255,0.3) 10px,
           transparent 10px,
           transparent 20px
         )`,
    },
  },
  orderLineContainer: {
    display: "flex",
    /*
        [theme.breakpoints.down('xs')]: {
          flexDirection: 'column'
        },
         */
  },
  cardContent: {
    "&:last-child": {
      padding: "16px",
    },
  },
  isDeleting: {
    opacity: 0.3,
  },
  productTextContainer: {
    display: "flex",
    flexGrow: 1,
    [theme.breakpoints.down("sm")]: {
      flexDirection: "column",
      flexBasis: "60%",
      flexShrink: 0,
      flexGrow: 0,
    },
  },
  orderLineInfo: {
    flexGrow: 1,
    flexShrink: 0,
    flexDirection: "column",
    flexBasis: "55%",
    marginRight: theme.spacing(1),
    display: "flex",
    [theme.breakpoints.down("sm")]: {
      marginBottom: theme.spacing(2),
      flexBasis: "auto",
      marginRight: 0,
    },
  },
  priceAndQuantity: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: theme.spacing(1),
  },
  productDeleteButton: {
    display: "flex",
    justifyContent: "flex-end",
    "& > button": {
      padding: "2px",
      "& .MuiIcon-root": {
        fontSize: "1.2rem",
      },
    },
  },
  quantityAndSummaryContainer: {
    flexBasis: "45%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(6),
    [theme.breakpoints.down("sm")]: {
      marginLeft: 0,
      flexBasis: "auto",
      marginRight: 0,
    },
  },
  quantityContainer: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    fontSize: "12px",
    textAlign: "center",
    [theme.breakpoints.up("sm")]: {
      fontSize: "15px",
      fontWeight: 400,
      textAlign: "center",
    },
    //marginBottom: theme.spacing(2)
  },
  innerQuantityContainer: {
    display: "flex",
    alignItems: "center",
    flexDirection: "column",
    [theme.breakpoints.up("sm")]: {
      flexDirection: "row",
    },
  },
  removeProductLink: {
    textDecoration: "underline",
    whiteSpace: "nowrap",
  },
  quantityText: {
    marginBottom: "3px",
    [theme.breakpoints.up("sm")]: {
      marginBottom: 0,
      marginRight: theme.spacing(2),
    },
  },
  quantityComponent: {
    marginRight: theme.spacing(1),
  },
  orderLineRebateContainer: {
    display: "flex",
    justifyContent: "space-between",
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
    "&.rebate-line": {
      paddingBottom: theme.spacing(1),
      borderBottom: `1px solid ${theme.palette.primary.light}`,
    },
  },
  orderLineTotalPriceContainer: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  orderLineTotalPrice: {
    fontSize: "15px",
    fontWeight: 500,
    "&.single-price": {
      paddingTop: theme.spacing(1),
    },
  },
  orderLinePriceLineDescription: {
    fontSize: "15px",
    fontWeight: 500,
  },
  orderLineRebateOldPrice: {
    fontSize: "16px",
    fontWeight: 500,
    color: "#A5A5A5",
    textDecoration: "line-through",
  },
  orderLinePrice: {
    fontSize: "15px",
    fontWeight: 500,
  },
  productName: {
    fontSize: "20px",
    fontWeight: 500,
    lineHeight: "1em",
    marginBottom: theme.spacing(2),
    color: theme.palette.primary.dark + "!important", // We need to remove global css for this
  },
  packageTemplateName: {
    fontSize: "12px",
    fontWeight: "normal",
  },
  subjectJobInfo: {
    fontStyle: "italic",
    fontWeight: "normal",
    fontSize: "15px",
  },
  packageProductList: {
    margin: 0,
    padding: 0,
    listStyle: "none",
    "& > li": {
      marginTop: theme.spacing(1),
      marginBottom: theme.spacing(1),
      fontWeight: 700,
    },
    "& > li > ul": {
      listStyle: "disc",
      paddingLeft: theme.spacing(2),
    },
  },
  cataloguePreviewContainer: {
    width: "100%",
    display: "flex",
    justifyContent: "center",
  },
  cataloguePreviewInnerContainer: {
    minWidth: "150px",
    display: "flex",
    justifyContent: "center",
  },
  digitalFilesPreviewList: {
    listStyle: "none",
    padding: 0,
    marginLeft: "-50px",
    display: "flex",
    flexWrap: "wrap",
    [theme.breakpoints.down("sm")]: {
      marginLeft: "-30px",
    },
    "& > li": {
      width: "30px",
      position: "relative",
      display: "flex",
      alignItems: "center",
      "& img": {
        maxWidth: "120px",
        maxHeight: "120px",
        backgroundColor: "white",
        display: "block",
        boxShadow: "0px 2px 6px #00000054",
      },
      [theme.breakpoints.down("sm")]: {
        width: "20px",
        "& img": {
          maxWidth: "80px",
          maxHeight: "80px",
          display: "block",
        },
      },
    },
    "& > li:last-child": {
      marginBottom: 0,
    },
  },
  retouchPicture: {
    border: `1px solid ${theme.palette.primary.main}`,
    maxWidth: "120px",
    maxHeight: "120px",
    backgroundColor: "white",
    display: "block",
  },
  digitalFileIconContainer: {
    width: "32px",
    height: "42px",
    zIndex: 2,
    position: "relative",
    left: "36px",
    top: "-49px",
  },
  packageProductPreviewList: {
    listStyle: "none",
    padding: 0,
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "center",
    [theme.breakpoints.down("sm")]: {
      flexDirection: "column",
      width: "100%",
      justifyContent: "center",
      padding: theme.spacing(2),
      boxSizing: "border-box",
    },
    "& > li": {
      display: "flex",
      alignItems: "center",
      width: "90px",
      position: "relative",
      marginBottom: theme.spacing(1),
      "& .template-inner-container": {
        boxShadow: "0px 2px 6px #00000054",
      },
      [theme.breakpoints.down("sm")]: {
        width: "100%",
        marginLeft: 0,
        marginRight: 0,
        marginTop: 0,
        display: "block",
        maxWidth: "none",
      },
    },
  },
  templateProductPreviewInnerContainer: {
    display: "flex",
    flexGrow: 1,
    alignItems: "center",
    justifyContent: "center",
    boxSizing: "border-box",
    padding: 0,
    maxWidth: "150px",
    "& .template-inner-container": {
      boxShadow: "0px 2px 6px #00000054",
    },
  },

  productSelect: {
    "& .MuiSelect-root": {
      padding: theme.spacing(1),
      fontSize: "12px",
    },
    "& .MuiSelect-selectMenu": {
      whiteSpace: "normal",
    },
  },
  subproductContainer: {
    marginBottom: theme.spacing(2),
    maxWidth: "300px",
  },
  productList: {
    listStyle: "none",
    padding: 0,
    "& > li": {
      marginBottom: theme.spacing(2),
    },
  },
  subProductList: {
    listStyle: "none",
    padding: 0,
    margin: 0,
    borderBottom: `1px solid ${theme.palette.primary.main}`,
    paddingBottom: theme.spacing(1),
    marginBottom: theme.spacing(1),
    "& > li": {
      display: "flex",
      justifyContent: "space-between",
    },
  },
}));

const ShoppingCartContent = () => {
  const { loading, items, summary, deleteItem, isUpdating } =
    useShoppingCart();
  const [deleteOrderLine, setDeleteOrderLine] = useState(null);
  const routes = useRoutes();
  const history = useHistory();
  useGoogleFonts(templateFontList);
  const isInitialized = useRef(false);
  const classes = useStyles();
  const [t] = useTranslation();

  useEffect(() => {
    if (loading || isInitialized.current) {
      return;
    }
    // Track views on first load only
    if (window.isEpmsAnalyticsFeatureEnabled && window.epmsAnalytics) {
      window.epmsAnalytics.onViewCart(items);
    }
    isInitialized.current = true;
  }, [loading]);

  useEffect(() => {
    if (!loading && items.length == 0) {
      history.push(routes["products.list"].path);
    }
  }, [loading, items]);

  const handleDelete = (e, orderLine) => {
    e.stopPropagation();
    e.preventDefault();
    setDeleteOrderLine(orderLine);
  };

  const doDelete = () => {
    setDeleteOrderLine(null);
    deleteItem(deleteOrderLine);
  };

  return (
    <Container maxWidth="lg" disableGutters={true}>
      <ul
        className={classes.productList}
        aria-label={t("Products in your cart") ?? ""}
      >
        {items
          .filter((orderLine) => orderLine.type === 0)
          .map((orderLine) => (
            <OrderLine
              key={orderLine.uuid}
              orderLine={orderLine}
              handleDelete={handleDelete}
            />
          ))}
      </ul>

      <Box mb={2} bt={2}>
        <OrderSummary summary={summary} isUpdating={isUpdating} />
      </Box>

      <Box mb={2} mt={2}>
        <Container>
          <ShoppingCartActions />
        </Container>
      </Box>
      <DeleteOrderLineDialog
        open={!!deleteOrderLine}
        handleOk={doDelete}
        handleCancel={() => setDeleteOrderLine(null)}
      />
    </Container>
  );
};

const ShoppingCartActions = () => {
  const routes = useRoutes();

  const buyMoreLinkAttributes = getLinkComponentAttributes(
    "products.list",
    routes,
  );
  const checkoutLinkAttributes = getLinkComponentAttributes(
    "checkout",
    routes,
  );

  return (
    <Box display="flex" justifyContent="space-between" mb={4}>
      <Box mr={1} flexGrow={1}>
        <Button
          size="large"
          color="primary"
          variant="outlined"
          mr={5}
          fullWidth
          {...buyMoreLinkAttributes}
        >
          <Trans>Add more</Trans>
        </Button>
      </Box>
      <Box ml={1} flexGrow={1}>
        <Button
          variant="contained"
          color="primary"
          size="large"
          fullWidth
          {...checkoutLinkAttributes}
        >
          <Trans>Checkout</Trans>
        </Button>
      </Box>
    </Box>
  );
};

export default ShoppingCartContent;

const getMobileEditLink = (orderLine, routes) => {
  if (orderLine.product.uuid == PRODUCT_CATALOGUE_UUID) {
    return false;
  }

  let link = `/shopping-cart/edit/${orderLine.uuid}`;
  if (
    productUuidIsDigitalFileProduct(orderLine.product.uuid) ||
    productUuidIsDigitalSetProduct(orderLine.product.uuid)
  ) {
    // Go to the first subject:
    const subject = orderLine.subjects[0];
    link = generatePath(routes["products.digitalportraits.subject"].path, {
      subjectUuid: subject.uuid,
    });
  } else if (orderLine.product.uuid === PRODUCT_RETOUCH_FILE_UUID) {
    link = generatePath(routes["shoppingcart.retouch"].path);
  }
  return { component: Link, to: link };
};

const getDesktopEditLink = (orderLine, routes) => {
  if (orderLine.product.uuid == PRODUCT_CATALOGUE_UUID) {
    return false;
  }

  let link = "";
  if (orderLine.product.uuid == PRODUCT_PACKAGE_UUID) {
    link =
      "/sections/cardscalendars/create_package.php?orderpart=" +
      orderLine.uuid;
  }

  if (
    productUuidIsDigitalFileProduct(orderLine.product.uuid) ||
    productUuidIsDigitalSetProduct(orderLine.product.uuid)
  ) {
    // Go to the first subject:
    const subject = orderLine.subjects[0];
    link = generatePath(routes["products.digitalportraits.subject"].path, {
      subjectUuid: subject.uuid,
    });
  }

  if (
    orderLine.product.type == 1 ||
    orderLine.product.type == 2 ||
    orderLine.product.type == 89
  ) {
    link =
      "/sections/cardscalendars/create_product.php?orderpart=" +
      orderLine.uuid;
  }

  if (orderLine.product.type == 11) {
    link = "/sections/shopping-cart/retouch";
  }

  return { component: "a", href: link };
};

const getEditLink = (orderLine, routes) => {
  if (getClientType() == "mobilev2") {
    return getMobileEditLink(orderLine, routes);
  } else {
    return getDesktopEditLink(orderLine, routes);
  }
};

const OrderLine = ({ orderLine, handleDelete }) => {
  const classes = useStyles();
  const { getProductByUuid } = usePriceList();
  const { t } = useTranslation();
  const isMobile = useIsMobileDevice();
  const product = getProductByUuid(orderLine.product.uuid);
  const routes = useRoutes();
  const theme = useTheme();

  const editLink = getEditLink(orderLine, routes);

  return (
    <Card square={true} elevation={1} component="li">
      <CardContent
        classes={{
          root: `${classes.cardContent} ${
            orderLine.isDeleting ? classes.isDeleting : ""
          }`,
        }}
      >
        <div className={classes.orderLineContainer}>
          <div
            className={`${classes.productPreviewContainer} ${
              orderLine.product.type == 200 ? "package" : ""
            } ${orderLine.product.type == 11 ? "retouch" : ""}`}
          >
            <ProductPreview orderLine={orderLine} />
            {isMobile && editLink && (
              <IconButton
                color="primary"
                variant="contained"
                aria-label={
                  orderLine.product.type == 200
                    ? t("Edit package")
                    : t("Edit product")
                }
                sx={{
                  position: "absolute",
                  right: "10px",
                  bottom: "-9px",
                  backgroundColor: theme.palette.primary.main,
                  "&&": {
                    color: "white",
                  },
                  "&&:visited,&&:link": {
                    color: "white",
                  },
                  borderRadius: "4px",
                  padding: "7px",
                  "& .material-icons": {
                    fontSize: "1rem",
                  },
                }}
                size="small"
                fullWidth={false}
                {...editLink}
              >
                <Icon>edit</Icon>
              </IconButton>
            )}
          </div>
          <div className={classes.productTextContainer}>
            {isMobile && (
              <div className={classes.productDeleteButton}>
                <IconButton
                  data-testid="remove-product-button"
                  aria-label={t("Remove product")}
                  color="primary"
                  onClick={(e) => handleDelete(e, orderLine)}
                >
                  <Icon>close</Icon>
                </IconButton>
              </div>
            )}
            <div className={classes.orderLineInfo}>
              <ProductInfo>
                <h2 className={classes.productName}>
                  {getProductTitle(orderLine, t)}
                </h2>
                <ProductDescription orderLine={orderLine} />
              </ProductInfo>

              {!isMobile && editLink && (
                <div>
                  <Button
                    variant="outlined"
                    color="primary"
                    fullWidth={false}
                    size="small"
                    {...editLink}
                  >
                    {getEditContentText(orderLine, t)}
                  </Button>
                </div>
              )}
            </div>
            <div className={classes.quantityAndSummaryContainer}>
              <div className={classes.priceAndQuantity}>
                {isMobile && orderLine.canChangeQuantity && (
                  <>
                    <PriceContainer>
                      {t("%s each", {
                        postProcess: "sprintf",
                        sprintf: [
                          orderLine.isUpdating
                            ? "..."
                            : formatCurrency(
                                orderLine.linePrice / orderLine.quantity,
                              ),
                        ],
                      })}
                    </PriceContainer>
                    <div className={classes.quantityContainer}>
                      <div className={classes.innerQuantityContainer}>
                        <label
                          htmlFor={"order_line_" + orderLine.uuid}
                          className={classes.quantityText}
                        >
                          <Trans>Quantity</Trans>
                        </label>
                        <Quantity
                          id={"order_line_" + orderLine.uuid}
                          orderLine={orderLine}
                          product={product}
                          disabled={!orderLine.canChangeQuantity}
                        />
                      </div>
                    </div>
                  </>
                )}
                {!isMobile && (
                  <>
                    <div className={classes.quantityContainer}>
                      <div className={classes.innerQuantityContainer}>
                        <label
                          htmlFor={"order_line_" + orderLine.uuid}
                          className={classes.quantityText}
                        >
                          <Trans>Quantity</Trans>
                        </label>
                        <Quantity
                          id={"order_line_" + orderLine.uuid}
                          className={classes.quantityComponent}
                          orderLine={orderLine}
                          product={product}
                          disabled={!orderLine.canChangeQuantity}
                        />
                      </div>
                    </div>
                    <div>
                      <MUILink
                        component="button"
                        className={classes.removeProductLink}
                        onClick={(e) => handleDelete(e, orderLine)}
                        data-testid="remove-product-button"
                      >
                        <Trans>Remove product</Trans>
                      </MUILink>
                    </div>
                  </>
                )}
              </div>
              <OrderLinePriceSummary orderLine={orderLine} />
            </div>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

const Quantity = ({ id, orderLine, product, disabled, className }) => {
  const [quantity, setQuantity] = useState(orderLine.quantity);
  const { changeItemQuantity } = useShoppingCart();

  useEffect(() => {
    setQuantity(() => {
      return orderLine.quantity;
    });
  }, [orderLine.quantity]);

  const handleChange = (e) => {
    let value = parseInt(e.target.value);

    if (isNaN(value) || value < product.minorderpartquantity) {
      value = product.minorderpartquantity;
    }
    changeItemQuantity(orderLine, value);
  };

  return (
    <QuantitySelector
      id={id}
      minQuantity={product.minorderpartquantity}
      maxQuantity={
        orderLine.maximumQuantity > 0 ? orderLine.maximumQuantity : null
      }
      quantity={quantity}
      onChange={handleChange}
      disabled={disabled}
      className={className}
    />
  );
};

export const ProductPreview = ({ orderLine }) => {
  switch (orderLine.product.type) {
    case 89:
    case 1:
    case 2:
      if (!orderLine.template) {
        return null;
      }
      return (
        <TemplateProductPreviewContainer
          templateUuid={orderLine.template.uuid}
          userResources={orderLine.template.data.userResources}
          year={orderLine.template.data.year}
          clientCompatibilityDate={
            orderLine.template.data.clientCompatibilityDate
          }
        />
      );
    case 200:
      return <PackageProductPreview orderLine={orderLine} />;
    case 11:
      return <RetouchFilePreview orderLine={orderLine} />;
  }

  if (productUuidIsDigitalFileProduct(orderLine.product.uuid)) {
    return <DigitalFilesPreview orderLine={orderLine} />;
  } else if (productUuidIsDigitalSetProduct(orderLine.product.uuid)) {
    return <DigitalSetPreview orderLine={orderLine} />;
  } else if (orderLine.product.uuid == PRODUCT_CATALOGUE_UUID) {
    return <CataloguePreview />;
  }
  return null;
};

const TemplateProductPreviewContainer = ({
  templateUuid,
  userResources,
  year,
  clientCompatibilityDate,
}) => {
  const classes = useStyles();

  return (
    <Box display="flex" flexGrow={1} justifyContent="center">
      <div className={classes.templateProductPreviewInnerContainer}>
        <TemplateProductPreview
          templateUuid={templateUuid}
          userResources={userResources}
          year={year}
          verticalAlign="center"
          clientCompatibilityDate={clientCompatibilityDate}
        />
      </div>
    </Box>
  );
};

const PackageProductPreview = ({ orderLine }) => {
  const classes = useStyles();
  return (
    <ul className={classes.packageProductPreviewList}>
      {orderLine.package.packageItems.map((packageItem, index) => {
        if (packageItem.type == "TEMPLATE_PRODUCT") {
          return (
            <li key={index}>
              <TemplateProductPreview
                templateUuid={packageItem.template.uuid}
                userResources={packageItem.templateData.userResources}
                year={packageItem.templateData.year}
                clientCompatibilityDate={
                  packageItem.templateData.clientCompatibilityDate
                }
              />
            </li>
          );
        } else if (packageItem.type == "CATALOGUE") {
          return (
            <li key={index}>
              <CatalogueIcon />
            </li>
          );
        } else {
          return null;
        }
      })}
    </ul>
  );
};

const CataloguePreview = () => {
  const classes = useStyles();
  return (
    <div className={classes.cataloguePreviewContainer}>
      <div className={classes.cataloguePreviewInnerContainer}>
        <CatalogueIcon />
      </div>
    </div>
  );
};

const DigitalFilesPreview = ({ orderLine }) => {
  const classes = useStyles();
  return (
    <Box display="flex" flexGrow={1} justifyContent="center">
      <ul className={classes.digitalFilesPreviewList}>
        {orderLine.digitalFiles.slice(0, 3).map((digitalFile) => {
          return (
            <li key={digitalFile.uuid}>
              <EpmsImage uuid={digitalFile.uuid} />
            </li>
          );
        })}
      </ul>
    </Box>
  );
};

const RetouchFilePreview = ({ orderLine }) => {
  const classes = useStyles();
  const fileUuid = orderLine.fileRetouch?.file?.uuid;
  if (!fileUuid) {
    return null;
  }

  return (
    <Box
      display="flex"
      flexGrow={1}
      justifyContent="center"
      alignItems="center"
    >
      <EpmsImage uuid={fileUuid} className={classes.retouchPicture} />
    </Box>
  );
};

const DigitalSetPreview = ({ orderLine }) => {
  const classes = useStyles();
  return (
    <Box
      display="flex"
      flexGrow={1}
      justifyContent="center"
      alignItems="center"
    >
      <ul className={classes.digitalFilesPreviewList}>
        {orderLine.digitalFiles.slice(0, 3).map((digitalFile) => {
          return (
            <li key={digitalFile.uuid}>
              <EpmsImage uuid={digitalFile.uuid} />
            </li>
          );
        })}
      </ul>
      <div className={classes.digitalFileIconContainer}>
        <DigitalFileIcon />
      </div>
    </Box>
  );
};

const OrderSummary = ({ summary, isUpdating }) => {
  const classes = useStyles();

  if (summary.length == 0) {
    return null;
  }

  const totalOL = summary.find((ol) => ol.type == 4);

  return (
    <section>
      <ul className={classes.summaryList}>
        {summary
          .filter((ol) => ol.type != 4)
          .map((ol, idx) => (
            <li key={idx} color="primary">
              <div className={classes.summaryDescription}>
                {ol.description}
              </div>
              <div className={classes.summaryDescription}>
                {isUpdating ? "..." : formatCurrency(ol.linePrice)}
              </div>
            </li>
          ))}
        <li color="primary">
          <div className={classes.summaryTotal}>{totalOL.description}</div>
          <div className={classes.summaryTotal}>
            {isUpdating ? "..." : formatCurrency(totalOL.linePrice)}
          </div>
        </li>
      </ul>
    </section>
  );
};

export const ProductDescription = ({ orderLine }) => {
  if (orderLine.product.type == 200) {
    return <PackageDescription orderLine={orderLine} />;
  } else if ([89, 2, 1].indexOf(orderLine.product.type) >= 0) {
    return <TemplateProductDescription orderLine={orderLine} />;
  } else if (productUuidIsDigitalFileProduct(orderLine.product.uuid)) {
    return <DigitalFilesDescription orderLine={orderLine} />;
  } else if (productUuidIsDigitalSetProduct(orderLine.product.uuid)) {
    return <DigitalSetDescription orderLine={orderLine} />;
  } else if (orderLine.product.uuid == PRODUCT_CATALOGUE_UUID) {
    return <CatalogueDescription orderLine={orderLine} />;
  }

  return null;
};

const CatalogueDescription = ({ orderLine }) => {
  const classes = useStyles();
  const { catalogue } = orderLine;

  return (
    <ul className={classes.packageProductList}>
      <li>
        <div>{catalogue.name}</div>
        <div className={classes.packageTemplateName}>
          {catalogue.subject.name}
        </div>
      </li>
    </ul>
  );
};

const DigitalFilesDescription = ({ orderLine }) => {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <ul className={classes.packageProductList}>
      {orderLine.subjects.map((subject) => {
        return (
          <li key={subject.uuid}>
            <div>{subject.name}</div>
            <div className={classes.subjectJobInfo}>
              {subject.job.name} {subject.group}
            </div>
            <div className={classes.packageTemplateName}>
              {t("%d picture files", {
                postProcess: "sprintf",
                sprintf: [subject.numImages],
              })}
            </div>
          </li>
        );
      })}
    </ul>
  );
};

const DigitalSetDescription = ({ orderLine }) => {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <ul className={classes.packageProductList}>
      {orderLine.subjects.map((subject) => {
        return (
          <li key={subject.uuid}>
            <div>{subject.name}</div>
            <div className={classes.packageTemplateName}>{subject.group}</div>
            <div className={classes.packageTemplateName}>
              {t("%d picture files", {
                postProcess: "sprintf",
                sprintf: [orderLine.digitalFiles.length],
              })}
            </div>
          </li>
        );
      })}
    </ul>
  );
};

export const PackageDescription = ({ orderLine }) => {
  const products = orderLine.package.packageItems
    .reduce((products, packageItem) => {
      let product = products.find((p) => p.uuid == packageItem.product.uuid);
      if (!product) {
        product = {
          ...packageItem.product,
          packageItems: [],
        };
        products.push(product);
      }
      product.packageItems.push(packageItem);
      return products;
    }, [])
    .sort((a, b) => {
      return a.name.localeCompare(b.name);
    });

  const classes = useStyles();
  return (
    <ul className={classes.packageProductList}>
      {products.map((product) => {
        return (
          <li key={product.uuid}>
            {product.name}
            <ul>
              {product.packageItems.map((packageItem, index) => {
                return (
                  <li key={index}>
                    <div className={classes.packageTemplateName}>
                      {getPackageItemDescription(packageItem)}
                    </div>
                  </li>
                );
              })}
            </ul>
          </li>
        );
      })}
    </ul>
  );
};

const getPackageItemDescription = (packageItem) => {
  if (
    packageItem.type == "DIGITAL_SET" ||
    packageItem.type == "DIGITAL_FILE"
  ) {
    return `${packageItem.subject.group}: ${packageItem.subject.name}`;
  }

  if (packageItem.type == "CATALOGUE") {
    return packageItem.catalogue.name;
  }

  return packageItem.template.name;
};

const TemplateProductDescription = ({ orderLine }) => {
  const { getProductByUuid } = usePriceList();
  const product = getProductByUuid(orderLine.product.uuid);
  const isMobile = useIsMobileDevice();
  const { t } = useTranslation();
  const classes = useStyles();

  return (
    <div>
      {product.subproducts.length > 0 && (
        <div className={classes.subproductContainer}>
          <SubProductSelect
            product={product}
            orderLine={orderLine}
            subProductUuids={orderLine.subProductUuids}
          />
        </div>
      )}
      {orderLine.template.name}
      {!isMobile && (
        <div>
          {" "}
          {t("%s each", {
            postProcess: "sprintf",
            sprintf: [
              orderLine.isUpdating
                ? "..."
                : formatCurrency(orderLine.linePrice / orderLine.quantity),
            ],
          })}
        </div>
      )}
    </div>
  );
};

const OrderLinePriceSummary = ({ orderLine }) => {
  return (
    <div>
      {orderLine.rebate && <SummaryRebatePrice orderLine={orderLine} />}
      <SubProductOptions orderLine={orderLine} />
      <TotalOrderLinePrice orderLine={orderLine} />
    </div>
  );
};

const SubProductSelect = ({ product, subProductUuids, orderLine }) => {
  const classes = useStyles();
  const { queuedUpdateItem } = useShoppingCart();

  const handleChange = (e) => {
    queuedUpdateItem({
      ...orderLine,
      subProductUuids: [e.target.value],
    });
  };
  // We don't have multiple subproducts, do we?

  return (
    <div>
      <FormControl fullWidth variant="filled">
        <Select
          className={classes.productSelect}
          labelId="select-sub-product"
          id="select-sub-product"
          value={subProductUuids[0]}
          size="small"
          /*renderValue={(value) => {
                    return <div>
                        <div>{value}</div>
                        <div className={classes.subProduct}> - Med hvit konvolutt</div>
                    </div>
                }}*/
          onChange={handleChange}
        >
          {product.subproducts.map((subproduct) => {
            return (
              <MenuItem key={subproduct.uuid} value={subproduct.uuid}>
                {subproduct.name}
              </MenuItem>
            );
          })}
        </Select>
      </FormControl>
    </div>
  );
};

const SummaryRebatePrice = ({ orderLine }) => {
  const classes = useStyles();
  return (
    <>
      <div className={classes.orderLineRebateContainer}>
        <div className={classes.orderLinePriceLineDescription}>
          <Trans>Original price</Trans>
        </div>
        <div className={classes.orderLineRebateOldPrice}>
          {orderLine.isUpdating ? "..." : formatCurrency(orderLine.linePrice)}
        </div>
      </div>

      <div className={`${classes.orderLineRebateContainer} rebate-line`}>
        <div className={classes.orderLinePriceLineDescription}>
          <Trans>Rebate</Trans>
        </div>
        <div className={classes.orderLinePrice}>
          {orderLine.isUpdating
            ? "..."
            : formatCurrency(orderLine.rebate.linePrice)}
        </div>
      </div>
    </>
  );
};

const SubProductOptions = ({ orderLine }) => {
  const classes = useStyles();
  const { getProductByUuid } = usePriceList();

  const product = getProductByUuid(orderLine.product.uuid);

  if (orderLine.subProductUuids.length === 0) {
    return null;
  }

  const subProductUuidNamePriceMap = product.subproducts.reduce(
    (map, subproduct) => {
      map[subproduct.uuid] = {
        name: subproduct.name,
        price: subproduct.extraprice,
        uuid: subproduct.uuid,
      };
      return map;
    },
    {},
  );

  return (
    <ul className={classes.subProductList}>
      {orderLine.subProductUuids.map((subProductUuid) => {
        const subProduct = subProductUuidNamePriceMap[subProductUuid];
        return (
          <li key={subProduct.uuid}>
            <div>{subProduct.name}</div>
            <div>{formatCurrency(subProduct.price)}</div>
          </li>
        );
      })}
    </ul>
  );
};

const TotalOrderLinePrice = ({ orderLine }) => {
  const classes = useStyles();

  return (
    <div className={classes.orderLineTotalPriceContainer}>
      <div className={classes.orderLinePriceLineDescription}>
        <Trans>Subtotal</Trans>
      </div>
      <div className={`${classes.orderLineTotalPrice}`}>
        {orderLine.isUpdating
          ? "..."
          : formatCurrency(orderLine.actualLinePrice)}
      </div>
    </div>
  );
};

const getEditContentText = (orderLine, t) => {
  if (orderLine.product.type === 11) {
    return t("Edit retouch options");
  }
  return t("Edit content");
};
